import { create } from "zustand";

/**
 * Open state of the notification settings dialog. Lives outside the profile
 * menu for the same reason as the changelog's: the menu sits in the sidebar,
 * which is a different React subtree below the `md` breakpoint (a sheet), so a
 * resize across it unmounted the menu and an open dialog with it. The dialog
 * mounts once in the router, beside the sidebar.
 */
type NotificationSettingsDialogState = {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
};

export const useNotificationSettingsDialogStore =
  create<NotificationSettingsDialogState>((set) => ({
    isOpen: false,
    setOpen: (open) => set({ isOpen: open }),
  }));
